var formsHelper = require('../utils/forms_helper');

window.helper = (function() {
  'use strict';

  // private functions
  function hideModal($modal) {
    var xmlhttp,
        url,
        launcher = $modal.attr('data-modal'),
        launcherEl = jQuery('[data-modal="' + launcher + '"]');

    let event = new CustomEvent('hide', {detail: {id:launcher}});

    if (jQuery($modal).hasClass('modal__no-close') === false) {
      // stops playing video's when modal is closed
      jQuery($modal).find('iframe').attr('src', jQuery($modal).find('iframe').attr('src'));
      $modal.removeClass('is-shown')
        .attr('aria-hidden', true);

      if (jQuery('.modal.is-shown').length === 0) {
        jQuery('html').css('overflow', 'scroll');
        jQuery('body').unbind('touchmove');
        jQuery('body').removeClass('modal--is-shown');
        jQuery('.nav__login').removeClass('modal--open');
      }

      window.dispatchEvent(event)
    }

    // (re-)focus modal launching element when modal closes
    setTimeout(function() {
      launcherEl.focus();
    }, 200);

    if (window.location.href.split('/#').length > 1) {
      url = window.location.href.split('/#')[0];
      window.location.replace(url);
    }
  }

  function ga4(modalName, path) {
    /* eslint-disable no-undef,
                      camelcase */
    _st.event.publish('virtual_pageview', '', {
      page_title: document.title + ' | ' + modalName,
      page_location: location.href.toLowerCase(),
      page_path: path + '/' + modalName
    });
  }

  function pageview($modal) {
    var modalName, path;

    if (!$modal) {
      return;
    }

    modalName = $modal.data('modal-name');

    if (modalName && typeof ga !== 'undefined') {
      path = location.pathname.toLowerCase();
      if (path.endsWith('/')) {
        path = path.slice(0, -1);
      }

      ga4(modalName, path);
    }
  }

  return {
    bindModal: function($modal) {
      var $window = $modal.find('.modal__window, .modal__container'),
          $buttonClose = $modal.find('.js-close-button'),
          closeOnBodyClick = $modal.data('close-on-body-click');

      if ((typeof closeOnBodyClick === 'undefined') || closeOnBodyClick) {
        $window.on('click', function($e) {
          $e.stopPropagation();
        });

        $modal.on('click', function($e) {
          var dataCloseAttr = jQuery(this).data('close-on-body-click');

          if ((typeof dataCloseAttr === 'undefined') || dataCloseAttr) {
            $e.preventDefault();
            hideModal($modal);
          }
        });
      }

      $buttonClose.on('click', function($e) {
        $e.preventDefault();
        hideModal($modal);
      });
    },
    hideModal: function($modal) {
      hideModal($modal);
    },
    showModal: function($modal, $disableAnimation) {
      var timeOut = 200;

      if ($disableAnimation) {
        timeOut = 0;
      }

      setTimeout(function() {
        if (!$modal.hasClass('header-modal')) {
          jQuery('html').css('overflow', 'hidden');
        };
        jQuery('body').addClass('modal--is-shown');

        $modal.addClass('is-shown');

        if ($modal.find('.ipo-mdc-form--parsley-form').length > 0) {
          formsHelper.reInitForms();
        }

        pageview($modal);

        $modal.attr('aria-hidden', false);

        jQuery('body').on('keydown', function($e) {
          // if escape pressed
          if ($e.which === 27) {
            $e.preventDefault();
            hideModal($modal);
          }
        });
      }, timeOut);
    }
  };
})();
